// extracted by mini-css-extract-plugin
export var actions = "_ma-d";
export var benefitCard = "_ma-a";
export var benefitIcon = "_ma-b";
export var benefitLabel = "_ma-c";
export var benefits = "_ma-9";
export var bodyText = "_ma-8";
export var closeButton = "_ma-2";
export var content = "_ma-3";
export var eyebrow = "_ma-4";
export var heading = "_ma-5";
export var image = "_ma-f";
export var imagePanel = "_ma-e";
export var modal = "_ma-0";
export var shell = "_ma-1";
export var title = "_ma-6";
export var titleOffer = "_ma-7";